import React from "react";
import { withTranslation } from "react-i18next";
import { Container, Row, Col } from "reactstrap";

const Footer = ({ t }) => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <div className="text-sm-end d-none d-sm-block">
                {t("Design & Developed by")}{" "}
                <a
                  style={{ color: "var(--brand)" }}
                  href="https://www.code-brew.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Code Brew Labs
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default withTranslation()(Footer);
